import React, { useEffect } from "react";

import { Col, Row } from "react-bootstrap";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";

import { Loader } from "../../../../../components/Loader/Loader";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "lucide-react";

// ✅ IMPORT API
import {
  PLNormal,
  PLNormalFan,
} from "../../../../../Redux/Slice/Fas/Financial Statement/Profit And Loss/ProfitAndLossSlice";
import { useTheme } from "../../../../../Themecontext/Themecontext";
import FASparentMultipalChild from "../../../../../components/Tables/FASparentMultipalChild";

export default function StatementNormal({ selectedIds, Fromdate, ToDate }) {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { PLNormaldata } = useSelector((state) => state.ProFitAndLossSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const FinancialYear = Cookies.get("FinancialYear");
  const Firm = Cookies.get("Firm");
  const { theme } = useTheme();
  const isdark = theme;

  useEffect(() => {
    dispatch(PLNormalFan());
    dispatch(
      PLNormal({
        Firm,
        Year: FinancialYear,
        selectedIds,
        Fromdate,
        ToDate,
      }),
    );
  }, [dispatch, Firm, FinancialYear, selectedIds, Fromdate, ToDate]);

  const formatIndianRupee = (amount) =>
    new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);

  /* ================= DATA ================= */

  const getRows =
    PLNormaldata?.Detail?.map((label, index) => ({
      srNumber: index + 1,
      AcLaieName: label.AcLaieName,
      GroupMStName: label.GroupMStName,
      acname: label.acname,
      Groupseq: label.Groupseq,
      BalAmt: label.BalAmt,
    })) || [];

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Type",
      key: "AcLaieName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Count", key: "count", align: "center" },
    {
      label: "AcGroup Name",
      key: "GroupMStName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Ac Name",
      key: "acname",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Net Amt", key: "BalAmt", align: "right", format: true },
  ];

  /* ================= PDF ================= */

  // const handleDownload = () => {
  //   const doc = new jsPDF({
  //     orientation: "landscape",
  //     unit: "mm",
  //     format: "a4",
  //   });

  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const marginX = 14;
  //   let startY = 20;

  //   /* ================= TITLE ================= */
  //   doc.setFontSize(14);
  //   doc.setFont(undefined, "bold");

  //   doc.text("Statement Normal", pageWidth / 2, 12, {
  //     align: "center",
  //   });

  //   doc.line(marginX, 15, pageWidth - marginX, 15);

  //   /* ================= FIRM NAME ================= */
  //   const firmName = DataMain?.Firm_List?.[0]?.GroupName || Firm || "";

  //   doc.setFontSize(12);
  //   doc.setFont(undefined, "bold");

  //   if (firmName) {
  //     doc.text(firmName, pageWidth / 2, startY, {
  //       align: "center",
  //     });
  //   }

  //   startY += 10;

  //   /* ================= TABLE DATA ================= */

  //   const tableColumn = [
  //     "Sr No",
  //     "Ac Type",
  //     "Ac Group",
  //     "Account Name",
  //     "Net Amount",
  //   ];

  //   const tableRows = getRows.map((row) => [
  //     row.srNumber,
  //     row.AcLaieName || "",
  //     row.GroupMStName || "",
  //     row.acname || "",
  //     Number(row.BalAmt || 0).toLocaleString("en-IN", {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2,
  //     }),
  //   ]);

  //   /* ================= TOTAL ================= */

  //   const totalAmount = getRows.reduce(
  //     (sum, row) => sum + Number(row.BalAmt || 0),
  //     0,
  //   );

  //   tableRows.push([
  //     "",
  //     "",
  //     "",
  //     "TOTAL",
  //     totalAmount.toLocaleString("en-IN", {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2,
  //     }),
  //   ]);

  //   /* ================= TABLE ================= */

  //   autoTable(doc, {
  //     startY,

  //     margin: {
  //       left: 18,
  //       right: 18,
  //     },

  //     head: [tableColumn],
  //     body: tableRows,

  //     theme: "grid",

  //     styles: {
  //       fontSize: 9,
  //       cellPadding: 3,
  //       fontStyle: "bold",
  //       valign: "middle",
  //     },

  //     headStyles: {
  //       fillColor: [220, 220, 220],
  //       textColor: [0, 0, 0],
  //       fontStyle: "bold",
  //       halign: "center",
  //     },

  //     columnStyles: {
  //       0: {
  //         halign: "center",
  //         cellWidth: 18,
  //       },

  //       1: {
  //         cellWidth: 45,
  //       },

  //       2: {
  //         cellWidth: 55,
  //       },

  //       3: {
  //         cellWidth: 85,
  //       },

  //       4: {
  //         halign: "right",
  //         cellWidth: 35,
  //       },
  //     },

  //     didParseCell(data) {
  //       const isTotalRow = data.row.raw?.[3] === "TOTAL";

  //       if (isTotalRow) {
  //         data.cell.styles.fontStyle = "bold";
  //         data.cell.styles.fillColor = [235, 235, 235];
  //       }
  //     },
  //   });

  //   /* ================= SAVE ================= */

  //   doc.save("Statement_Normal.pdf");
  // };

  const formatAmount = (value) => {
    if (value === null || value === undefined || value === "") return "0.00";
    const num = Number(value);
    return isNaN(num) ? "0.00" : num.toFixed(2); // always 2 decimals
  };

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    /* ================= TITLE ================= */
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    const title = "Profit & Loss - Normal Statement";
    doc.text(title, pageWidth / 2, 15, { align: "center" });
    doc.setLineWidth(0.5);
    doc.line(marginX, 18, pageWidth - marginX, 18);

    /* ================= FIRM NAME (CENTER) ================= */
    const firmName =
      DataMain?.Firm_List?.[0]?.GroupName ||
      DataMain?.Firm_Dtl?.[0]?.FirmName ||
      Firm ||
      "";

    let yPos = 25;

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");

    if (firmName) {
      doc.text(firmName, pageWidth / 2, yPos, {
        align: "center",
      });
    }

    yPos += 2;
    /* ================= SPLIT DATA ================= */
    const incomeRows = (PLNormaldata?.Detail || []).filter((r) =>
      (r.AcLaieName || "").toLowerCase().includes("income"),
    );

    const expenseRows = (PLNormaldata?.Detail || []).filter((r) =>
      (r.AcLaieName || "").toLowerCase().includes("expense"),
    );

    /* ================= TOTAL CALC ================= */
    const calcTotals = (rows) => ({
      debit: rows.reduce((s, r) => s + Number(r.Debit || 0), 0),
      credit: rows.reduce((s, r) => s + Number(r.Credit || 0), 0),
    });

    const incomeTotals = calcTotals(incomeRows);
    const expenseTotals = calcTotals(expenseRows);

    /* ================= TABLE ALIGN ================= */
    const tableWidth = 190;
    const tableLeftMargin = (pageWidth - tableWidth) / 2;

    /* ================= INCOME TABLE ================= */
    let incomeSr = 1;
    const incomeTableRows = incomeRows.map((row) => [
      incomeSr++,
      row.AcLaieName || "",
      row.GroupMStName || "",
      row.acname || "",
      formatAmount(row.Debit),
      formatAmount(row.Credit),
    ]);

    incomeTableRows.push([
      "",
      "",
      "",
      "INCOME TOTAL",
      formatAmount(incomeTotals.debit),
      formatAmount(incomeTotals.credit),
    ]);

    autoTable(doc, {
      startY: yPos + 5,
      margin: { left: tableLeftMargin },

      head: [
        ["Sr. No.", "Ac Type", "Ac Group Name", "Ac Name", "Debit", "Credit"],
      ],

      body: incomeTableRows,
      theme: "grid",
      styles: {
        fontSize: 8,
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
        cellPadding: 2,
        valign: "middle",
        overflow: "linebreak",
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        fontSize: 9,
      },

      columnStyles: {
        0: { halign: "center", cellWidth: 15 },
        1: { halign: "left", cellWidth: 30 },
        2: { halign: "left", cellWidth: 45 },
        3: { halign: "left", cellWidth: 50 },
        4: { halign: "right", cellWidth: 25 },
        5: { halign: "right", cellWidth: 25 },
      },

      didParseCell(data) {
        if (data.row.raw[3] === "INCOME TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [230, 230, 230];
        }
      },

      showHead: "everyPage",
    });

    /* ================= EXPENSE TABLE ================= */
    let expenseSr = 1;
    const expenseTableRows = expenseRows.map((row) => [
      expenseSr++,
      row.AcLaieName || "",
      row.GroupMStName || "",
      row.acname || "",
      formatAmount(row.Debit),
      formatAmount(row.Credit),
    ]);

    expenseTableRows.push([
      "",
      "",
      "",
      "EXPENSE TOTAL",
      formatAmount(expenseTotals.debit),
      formatAmount(expenseTotals.credit),
    ]);

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 12,
      margin: { left: tableLeftMargin },

      head: [
        ["Sr. No.", "Ac Type", "Ac Group Name", "Ac Name", "Debit", "Credit"],
      ],

      body: expenseTableRows,
      theme: "grid",

      styles: {
        fontSize: 9,
        textColor: [0, 0, 0],
        cellPadding: 2,
        valign: "middle",
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
      },

      columnStyles: {
        0: { halign: "center", cellWidth: 15 },
        1: { halign: "left", cellWidth: 30 },
        2: { halign: "left", cellWidth: 45 },
        3: { halign: "left", cellWidth: 50 },
        4: { halign: "right", cellWidth: 25 },
        5: { halign: "right", cellWidth: 25 },
      },

      didParseCell(data) {
        if (data.row.raw[3] === "EXPENSE TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [230, 230, 230];
        }
      },

      showHead: "everyPage",

      didDrawPage() {
        const pageNo = doc.internal.getCurrentPageInfo().pageNumber;
        doc.setFontSize(8);
        doc.text(`Page ${pageNo}`, marginX, pageHeight - 5);
      },
    });

    /* ================= STATUS / AMOUNT ================= */
    const summary = PLNormaldata?.Summary?.[0] || {};
    const finalY = doc.lastAutoTable.finalY + 12;

    doc.setFontSize(11);
    doc.setFont(undefined, "bold");

    doc.text(`Status : ${summary?.Status || ""}`, marginX, finalY);
    doc.text(
      `Amount : ${formatAmount(summary?.Amount)}`,
      pageWidth - marginX,
      finalY,
      { align: "right" },
    );

    doc.setLineWidth(0.3);
    doc.line(marginX, finalY + 3, pageWidth - marginX, finalY + 3);

    /* ================= SAVE ================= */
    doc.save("PL_Normal_Statement.pdf");
  };
  const parentTotals =
    PLNormaldata?.GrpSummaryparent?.reduce((acc, item) => {
      acc[item.AcLaieName] = {
        BalAmt: item.BalAmt,
      };
      return acc;
    }, {}) || {};
  const summary = PLNormaldata?.Summary?.[0];

  if (summary) {
    parentTotals["Expenses"] = {
      ...(parentTotals["Expenses"] || {}),
      BalAmt: summary.Debit,
    };

    parentTotals["Income"] = {
      ...(parentTotals["Income"] || {}),
      BalAmt: summary.Credit,
    };
  }

  const buildGroupTotals = (parentSummary = []) => {
    const totals = {};

    // -------------------------
    // Parent Summary
    // -------------------------
    parentSummary.forEach((item) => {
      // Parent Level Key
      const parentKey = `-${item.AcLaieName}-0`;

      totals[parentKey] = {
        ...item,
      };
    });
    return totals;
  };

  const groupTotals = buildGroupTotals(PLNormaldata?.ParentSummary || []);
  /* ================= LOADER ================= */

  if (PLNormaldata === "no" || PLNormaldata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  /* ================= UI ================= */

  return (
    <div
      style={{
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
      }}
    >
      <Row>
        <Col xs={12}>
          {/* HEADER */}
          <Row
            className="align-items-center"
            style={{
              marginBottom: "10px",
            }}
          >
            {/* Card */}
            <Col xl={6} lg={8} md={12} sm={12}>
              <div
                style={{
                  background:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour2,
                  border: `1px solid ${
                    isdark === "light"
                      ? iscolour?.Colour3
                      : iscolourDark?.Colour10
                  }`,
                  borderLeft: `6px solid ${
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour10
                  }`,
                  borderRadius: "12px",
                  padding: "12px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  height: "100%",
                }}
              >
                {/* Amount */}
                <h4
                  style={{
                    marginTop: "10px",
                    fontWeight: "500",
                    color:
                      isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour10,
                  }}
                >
                  {formatIndianRupee(PLNormaldata?.Summary?.[0]?.Amount)}
                </h4>

                {/* Title */}
                <h6
                  style={{
                    color:
                      isdark === "light"
                        ? iscolour?.Colour12
                        : iscolourDark?.Colour12,
                    fontWeight: "600",
                  }}
                >
                  {PLNormaldata?.Summary?.[0]?.Status} Amount
                </h6>
              </div>
            </Col>

            {/* Button */}
            <Col
              xl={6}
              lg={4}
              md={12}
              sm={12}
              className="d-flex justify-content-xl-end justify-content-lg-end justify-content-md-start mt-md-3 mt-3 mt-lg-0"
            >
              <button
                onClick={handleDownload}
                className="common-hover-btn"
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour4
                      : iscolourDark?.Colour6,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour11
                      : iscolourDark?.Colour12,
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  cursor: "pointer",
                  fontWeight: "500",
                  fontSize: "14px",
                  height: "44px",
                }}
              >
                <Download size={16} />
                Download PDF
              </button>
            </Col>
          </Row>

          {/* TABLE */}
          <div
            style={{
              marginTop: "20px",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour4,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour11,
                padding: "14px",
                margin: 0,
                position: "relative",
                zIndex: 2,
              }}
            >
              <h2
                style={{
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "600",
                }}
              >
                STATEMENT NORMAL
              </h2>
            </div>

            {/* <FASparentMultipalChild
              data={getRows}
              columns={getColumns}
              externalTotals={PLNormaldata?.Summary?.[0] || {}}
              parentTotals={parentTotals}
            /> */}

            <FASparentMultipalChild
              data={getRows}
              columns={getColumns}
              externalTotals={PLNormaldata?.Summary?.[0] || {}}
              groupTotals={groupTotals}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}
